import { Component, inject, ChangeDetectionStrategy} from '@angular/core';
import { BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { RJobrunInstelling } from '@cumlaude/service-contract';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { DatePipe } from '@angular/common';
import { doorlooptijd } from '../../services/etl.service';
import { compareDates } from '@cumlaude/shared-utils';

@Component({
	selector: 'app-jobrun-instelling-dialog',
	templateUrl: './jobrun-instelling-details-dialog.component.html',
	styleUrls: ['./jobrun-instelling-details-dialog.component.scss'],
	imports: [BaseDialogComponent, ButtonComponent, DatePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobrunInstellingDetailsDialogComponent {
	protected readonly dialogRef = inject<DialogRef>(DialogRef);

	protected readonly data = inject<{
		jobrunInstelling: RJobrunInstelling;
	}>(DIALOG_DATA);

	protected readonly doorlooptijd = doorlooptijd;

	protected readonly jobrunDetails = this.data?.jobrunInstelling?.jobrunDetails?.sort((a, b) => {
		if (a.stapVa === undefined && b.stapVa === undefined) return 0;
		if (a.stapVa === undefined) return 1;
		if (b.stapVa === undefined) return -1;

		return compareDates(a.stapVa, b.stapVa);
	});
}
